// extracted by mini-css-extract-plugin
export default {"container":"Search_container__oCbId","info":"Search_info__l5702","query":"Search_query__Mw9Ff","results-number":"Search_results-number__haohi","pointer":"Search_pointer__UyyC3"};